// extracted by mini-css-extract-plugin
export default {"wrapper":"XV-z","ratingContainer":"YV-z","ratingValue":"ZV-z","starSprite":"_V-z","ratingLabel":"aW-z","error":"bW-z","errorBox":"cW-z"};